import { render } from "./ReOrderNew.vue?vue&type=template&id=f64392ea"
import script from "./ReOrderNew.vue?vue&type=script&lang=js"
export * from "./ReOrderNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__